import { useRouter } from "next/router";
import { CHECK_TOKEN_TIMEOUT, REFRESH_TOKEN } from "@/apollo/queries/user";
import routes from "@/lib/routes";
import { useApolloClient } from "@apollo/client";
export function useCheckTokenTimeout() {
  const router = useRouter();
  const client = useApolloClient();
  const checkTokenTimeoutAndRedirectOnError = async () => {
    const {
      data
    } = await client.query({
      query: CHECK_TOKEN_TIMEOUT,
      fetchPolicy: "network-only"
    });
    if (data) {
      var _data$checkTokenTimeo;
      if ((data === null || data === void 0 || (_data$checkTokenTimeo = data.checkTokenTimeout) === null || _data$checkTokenTimeo === void 0 ? void 0 : _data$checkTokenTimeo.result) === false) {
        await client.mutate({
          mutation: REFRESH_TOKEN,
          fetchPolicy: "network-only"
        });
        await router.push(routes.timeOut);
      }
    }
    return data;
  };
  return {
    checkTokenTimeoutAndRedirectOnError
  };
}